import { render, staticRenderFns } from "./TaskItemName.vue?vue&type=template&id=291cc908&scoped=true&"
import script from "./TaskItemName.vue?vue&type=script&lang=js&"
export * from "./TaskItemName.vue?vue&type=script&lang=js&"
import style0 from "./TaskItemName.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TaskItemName.vue?vue&type=style&index=1&id=291cc908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291cc908",
  null
  
)

export default component.exports